module.exports = __webpack_public_path__ + "Images/back.svg";


//////////////////
// WEBPACK FOOTER
// ./Images/back.svg
// module id = 1861
// module chunks = 2